// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__WiIV2","disabled":"Checkbox_disabled__ldVpl"};